"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ProgressBarMobile_1 = require("./ProgressBarMobile");
exports.default = ProgressBarMobile_1.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/atoms/ProgressBar/ProgressBarMobile/index.js
// module id = 531
// module chunks = 8